import React from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { DCard } from "@ui/components/card/DCard";
import { ITitle } from "@ui/components/title/ITitle";
import { StatusIndicator } from "@ui/components/status";
import { SMenuTrigger } from "@ui/components/menu/SMenu";
import { SButton } from "@ui/components/buttons/SButton";
import { colCenter } from "@ui/components/style/style";
import { PermissionChecker, Permission } from "@utility/permission-checker";
import { useTranslation } from "react-i18next";
import { formatUtcToLocalDateTimeString } from "@application/common/helpers/date-util";
export const UserProfileCard = ({ user, onEdit, onDelete, onMenuClick, }) => {
    const { t } = useTranslation(["common"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const formatLastVisit = (date) => {
        if (!date)
            return t("common:actions.never");
        return formatUtcToLocalDateTimeString(date);
    };
    if (isMobile) {
        return (React.createElement(DCard, { sx: { mb: 2 } },
            React.createElement(Box, { sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                } },
                React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                    React.createElement(Typography, { variant: "body1", fontWeight: 600 }, `${user.firstName} ${user.lastName}`),
                    React.createElement(Typography, { variant: "body2", color: "text.secondary" }, user.userId),
                    React.createElement(Box, { sx: { mt: 0.5 } },
                        React.createElement(StatusIndicator, { variant: user.isActive ? "active" : "inactive" }))),
                React.createElement(SMenuTrigger, { onClick: onMenuClick, size: "medium" })),
            React.createElement(Typography, { variant: "body2", color: "text.secondary" },
                t("common:labels.lastVisit"),
                ":",
                " ",
                formatLastVisit(user.lastLoginAt))));
    }
    return (React.createElement(DCard, { sx: { mb: 2 } },
        React.createElement(Grid, { container: true, spacing: 2, alignItems: "center" },
            React.createElement(Grid, { size: 6 },
                React.createElement(Typography, { variant: "body1", color: "textPrimary" }, `${user.firstName} ${user.lastName}`),
                React.createElement(ITitle, { title: t("common:labels.userInformation"), subtitle: React.createElement(Box, null,
                        React.createElement(StatusIndicator, { variant: user.isActive ? "active" : "inactive" })) })),
            React.createElement(Grid, { size: 6 },
                React.createElement(ITitle, { title: t("common:labels.lastVisit"), subtitle: formatLastVisit(user.lastLoginAt), rightComponent: React.createElement(Box, { sx: Object.assign(Object.assign({}, colCenter), { gap: 1 }) },
                        React.createElement(React.Fragment, null,
                            PermissionChecker.hasPermission(Permission.USERS_DELETE) && (React.createElement(SButton, { variant: "soft", onClick: onDelete }, t("common:actions.delete"))),
                            PermissionChecker.hasPermission(Permission.USERS_EDIT) && (React.createElement(SButton, { variant: "contained", onClick: onEdit }, t("common:actions.edit"))))) })))));
};
